import {ColorInput} from '@mantine/core';
import React, {useState} from 'react';

import {HEX_COLOR_PATTERN} from 'pipelines/StepShapeUtils';

const HEX_COLOR_REGEX = new RegExp(HEX_COLOR_PATTERN);

interface ColorEditorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export default function ColorEditor({value, onChange, disabled, className}: ColorEditorProps): JSX.Element {
  const [displayValue, setDisplayValue] = useState(value);

  function handleChange(newValue: string): void {
    setDisplayValue(newValue);
    if (HEX_COLOR_REGEX.test(newValue)) {
      onChange(newValue);
    }
  }

  // If the display value is a valid color that differs from props, the parent changed externally — reflect it.
  // If the display value is invalid/intermediate (user is typing), keep showing it.
  const resolvedValue = HEX_COLOR_REGEX.test(displayValue) && displayValue !== value ? value : displayValue;
  const isValid = HEX_COLOR_REGEX.test(resolvedValue);

  return (
    <ColorInput
      value={resolvedValue}
      onChange={handleChange}
      error={!isValid ? 'Enter a valid hex color (e.g. #FF0000)' : undefined}
      disabled={disabled}
      className={className}
    />
  );
}
